export default "__VITE_PUBLIC_ASSET__4097db5b__"